import { render, staticRenderFns } from "./Sign.vue?vue&type=template&id=c10a403e&scoped=true"
import script from "./Sign.vue?vue&type=script&lang=js"
export * from "./Sign.vue?vue&type=script&lang=js"
import style0 from "./Sign.vue?vue&type=style&index=0&id=c10a403e&prod&scoped=true&lang=css"
import style1 from "./Sign.vue?vue&type=style&index=1&id=c10a403e&prod&lang=css"
import style2 from "./Sign.vue?vue&type=style&index=2&id=c10a403e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10a403e",
  null
  
)

export default component.exports